import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { useState } from "react";

export default function useSort(dataObj, initField = "null", initDirection = "asc") {
  const [sortField, setSortField] = useState(initField);
  const [sortDirection, setSortDirection] = useState(initDirection);
  const doSort = (a, b, direction) => {
    if (a === null && b === null) {
      return 0;
    }
    if (direction === "asc") {
      if (a === null) {
        return 1;
      }
      if (b === null) {
        return -1;
      }
      if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b, "zh");
      }
      return a - b;
    }
    if (a === null) {
      return -1;
    }
    if (b === null) {
      return 1;
    }
    if (typeof a === "string" && typeof b === "string") {
      return b.localeCompare(a, "zh");
    }
    return b - a;
  };
  const sortedDataObj =
    dataObj === null
      ? null
      : [...dataObj].sort((aObj, bObj) => {
          const a = aObj[sortField];
          const b = bObj[sortField];

          if (typeof a === "object" && typeof b === "object" && a !== null && b !== null) {
            console.warn(
              "WARNING: comparing objects in sorting. Perhaps you have forgotten to flatten the data object.",
            );
            const _a = Object.values(a)[0];
            const _b = Object.values(b)[0];
            return doSort(_a, _b, sortDirection);
          }

          return doSort(a, b, sortDirection);
        });
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };
  const SortFieldIcon = ({ field = "null" }) => {
    return sortField === field ? (
      sortDirection === "asc" ? (
        <ArrowUpward />
      ) : (
        <ArrowDownward />
      )
    ) : null;
  };
  return [sortedDataObj, handleSort, SortFieldIcon];
}
